export default __webpack_public_path__ + "static/0320-505dffa97f2ad6cc2aa3b9339636d963.png";